import React, { createContext, useContext, useState, useCallback } from "react";
import { LANGUAGES, detectLanguage, interpolate } from "../i18n";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectLanguage);

  const setLang = useCallback((code) => {
    if (LANGUAGES[code]) {
      setLangState(code);
      localStorage.setItem("sensoria_lang", code);
      document.documentElement.lang = code;
    }
  }, []);

  /**
   * Translation function.
   * Usage: t("auth_login") or t("feed_char_count", { count: 42 })
   * Falls back to French, then to the key itself.
   */
  const t = useCallback(
    (key, vars) => {
      const str =
        LANGUAGES[lang]?.translations[key] ||
        LANGUAGES.fr.translations[key] ||
        key;
      return vars ? interpolate(str, vars) : str;
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
